// Win-back, 2 weeks after a lapse. MARKETING — pass `unsubscribeUrl` (PECR).

import type { EmailData } from "../../types";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) => "Your £25 Amazon voucher is still waiting";

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Your £25 voucher is waiting",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `Just a reminder that your ${b("£25 Amazon voucher")} is still available when you bring ${b(`'${esc(data.companyName)}'`)} back to ${brand.name}.`,
      ),
      p(
        "We'd love to look after your business again — and we'll search our panel to find you the right price.",
      ),
      p(`Call our UK-based team on ${call(brand)} for a fast, no-obligation quote.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
